<div class="container">
  <mat-card style="min-height: 200px">
    <mat-card-title class="text-center">
      Payment Failed <mat-icon>error</mat-icon>
    </mat-card-title>
  </mat-card>
</div>
